import * as axios from 'axios';

export class BaseService {
    static get API_KEY() {
        return process.env.VUE_APP_API_KEY;
    }

    static get API_URL() {
        return process.env.VUE_APP_API_URL || "https://api.ondagoapp.com";
    }

    getFromAPI(url) {
        const promise = new Promise((resolve, reject) => {
            axios.default.get(BaseService.API_URL + url, { headers: { apiKey: BaseService.API_KEY }}).then((response) => {
                if (response && response.data) {
                    resolve(response.data);
                } else {
                    resolve({})
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    getFromUrl(url) {
        const promise = new Promise((resolve, reject) => {
            axios.default.get(url).then((response) => {
                if (response && response.data) {
                    resolve(response.data);
                } else {
                    resolve(null);
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    postToAPI(url, data) {
        const promise = new Promise((resolve, reject) => {
            axios.default.post(BaseService.API_URL + url, data, {
                headers: { apiKey: BaseService.API_KEY }
            }).then((response) => {
                if (response && response.data) {
                    resolve(response.data);
                } else {
                    resolve({})
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    putToAPI(url, data) {
        const promise = new Promise((resolve, reject) => {
            axios.default.put(BaseService.API_URL + url, data, {
                headers: { apiKey: BaseService.API_KEY }
            }).then((response) => {
                if (response && response.data) {
                    resolve(response.data);
                } else {
                    resolve({})
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }

    deleteFromAPI(url) {
        const promise = new Promise((resolve, reject) => {
            axios.default.delete(BaseService.API_URL + url, {
                headers: { apiKey: BaseService.API_KEY }
            }).then((response) => {
                if (response && response.data) {
                    resolve(response.data);
                } else {
                    resolve({});
                }
            }).catch((error) => {
                reject(error);
            });
        });

        return promise;
    }
}